<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          custom-css="assets/css/interior.css" :language="$t('Language')"></snipp-current-user>
      </div>

      <section class="" data-screen-label="Register" v-if="registration_enabled">

        <div class="int-accents" aria-hidden="true">
          <img class="accent accent--lg"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-large.png"
            alt="" decoding="async">
          <img class="accent accent--md"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-medium.png"
            alt="" decoding="async">
          <img class="accent accent--ticket"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-golden-ticket.png"
            alt="" decoding="async">
          <img class="accent accent--sm"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-small.png"
            alt="" decoding="async">
        </div>
        <div class="int-body-inner">
          <div class="int-lede">
            <h2>Start Your Journey</h2>
          </div>
          <div class="reg-card">
            <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
              :show-confirmation="show_confirmation" custom-css="assets/css/interior.css" :is-logged-out="is_logged_out"
              @is-registered="handleIsRegistered" :language="$t('Language')"></snipp-registration>
          </div>
        </div>
      </section>

      <section id="upload-wrapper" v-if="upload_enabled">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="int-accents" aria-hidden="true">
            <img class="accent accent--sm" src="assets/images/accent-blimp-small.png" alt="" decoding="async"
              style="top:auto;left:40%;bottom:8%;transform:translateX(-50%);">
          </div>

          <div class="int-body-inner">
            <div class="up-head">
              <h2>The Gears Are Ready To Turn</h2>
              <p>Submit your qualifying receipt below so the factory can begin preparing what comes next.</p>
            </div>
            <div class="up-grid">
              <div class="up-tips">
                <div class="tip-card">
                  <span class="card-glow" aria-hidden="true"></span>
                  <span class="tip__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="4"></circle>
                      <path
                        d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4">
                      </path>
                    </svg></span>
                  <h4 class="tip__title">Good lighting</h4>
                  <p class="tip__desc">Lay your receipt flat on a bright, even surface before snapping your photo.</p>
                </div>
                <div class="tip-card">
                  <span class="card-glow" aria-hidden="true"></span>
                  <span class="tip__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path
                        d="M3 8V5a2 2 0 0 1 2-2h3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3">
                      </path>
                    </svg></span>
                  <h4 class="tip__title">All four corners</h4>
                  <p class="tip__desc">Make sure the full receipt is visible and fits within the frame.</p>
                </div>
                <div class="tip-card">
                  <span class="card-glow" aria-hidden="true"></span>
                  <span class="tip__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 2 2 7l10 5 10-5-10-5Z"></path>
                      <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
                    </svg></span>
                  <h4 class="tip__title">Long receipt?</h4>
                  <p class="tip__desc">Take multiple photos of the same receipt and upload them together.</p>
                </div>
              </div>
              <div class="up-check">
                <h3>Your receipt must show:</h3>
                <div class="reqs reqs--grid">
                  <div class="req"><span class="req__tick"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"
                        stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 8.5L6.5 12L13 4.5"></path>
                      </svg></span>Store or retailer name</div>
                  <div class="req"><span class="req__tick"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"
                        stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 8.5L6.5 12L13 4.5"></path>
                      </svg></span>Date of purchase <b>(8/15/26 – 1/18/27)</b></div>
                  <div class="req"><span class="req__tick"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"
                        stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 8.5L6.5 12L13 4.5"></path>
                      </svg></span>Qualifying limited-edition <b>Cocoa Loops cereal featuring Wonka Hat Marshmallows</b>
                    with dollar amounts</div>
                  <div class="req"><span class="req__tick"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"
                        stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 8.5L6.5 12L13 4.5"></path>
                      </svg></span>Total cost</div>
                </div>
              </div>
              <div class="up-online-card">
                <span class="up-online__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path>
                  </svg></span>
                <div>
                  <b>Online Purchases</b>
                  <p>For online orders, upload a complete image or PDF of your pick-up or delivery confirmation.</p>
                </div>
              </div>
              <div class="submit-card">
                <span class="card-glow" aria-hidden="true"></span>
                <div class="submit-card__head">
                  <span class="submit-card__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 2h14v20l-3-2-2 2-2-2-2 2-2-2-3 2V2Z"></path>
                      <path d="M9 8h6M9 12h6M9 16h4"></path>
                    </svg></span>
                  <h3>Submit Your Receipt</h3>
                </div>
                <div class="submit-card__body">
                  <div class="dropzone" id="dropzone">
                    <span class="dropzone__icon"><svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 13v8M8.5 16.5 12 13l3.5 3.5"></path>
                        <path d="M20 17.6A5 5 0 0 0 17 8.5h-1.3A7 7 0 1 0 4 14.9"></path>
                      </svg></span>
                    <p>JPG, PNG, GIF, TIFF or PDF formats, up to 10&nbsp;MB of all images in your submission.</p>
                    <snipp-upload :campaign-id="campaignId" include-upload-button="true"
                      @snipp-upload-result="handleSnippUploadResult" custom-css="assets/css/interior.css"
                      class="submit-card_btnWrapper" :language="$t('Language')"></snipp-upload>
                  </div>
                  <a href="javascript:void(0)" class="js-pp-open submit-card__link">View Eligible Products <span
                      class="chev" aria-hidden="true">&rsaquo;</span></a>
                  <a href="https://www.wkkellogg.com/where-to-buy#/US/any/products/~/~?dtr-selectedFilter={%22tags%22:%22Froot%20Loops%22}"
                    target="_blank" rel="noopener" class="submit-card__link">Find a Participating Retailer <span
                      class="chev" aria-hidden="true">&rsaquo;</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
    },
    handleSnippUploadResult() {
      // ✅ Redirect to the dedicated Thanks page after a successful upload
      this.$router.push('/thanks');
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>

</style>
